import { FC, SVGProps } from 'react'

import { cn } from '@/lib/utils'

type ChevronProps = {
  direction?: 'up' | 'right' | 'down' | 'left'
} & SVGProps<SVGSVGElement>

const Chevron: FC<ChevronProps> = ({
  direction = 'right',
  className,
  ...props
}) => {
  const rotationDegrees = {
    up: '-90deg',
    right: '0deg',
    down: '90deg',
    left: '180deg',
  }

  return (
    <svg
      aria-hidden="true"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotationDegrees[direction]})` }}
      className={cn(
        'inline-block transition-transform duration-150 ease-in-out',
        className
      )}
      {...props}
    >
      <path
        d="M1 1L7 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 13L7 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Chevron
